export default __webpack_public_path__ + "static/media/woman.78267668.svg";